import moment from 'moment-timezone';
import { toPng } from 'html-to-image';

export default {
    data() {
        return {
            // apiOperationUrl: 'https://api.morefurniture.id/uni/',// 'http://172.18.130.56:1234/api/',
            // apiOperationUrl:'https://api.mockfly.dev/mocks/a9c81cac-8069-42d9-8c2a-b71949b7e15e/'
        };
    },
    methods: {
        CheckPaymentStatusNota(grandTotal,PayTotal){
            if(PayTotal < grandTotal && grandTotal > 0 && PayTotal > 0){
                return "DP";
            }else if(PayTotal == grandTotal){
                return "LUNAS";
            }else if(PayTotal > grandTotal){
                return "LEBIH BAYAR";
            }else if(PayTotal == 0){
                return "BELUM BAYAR";
            }else{
                return "-";
            }
        },
        checkIsThisLive(){
            return window.location.origin.replaceAll('http://','').replaceAll('https://','').startsWith('expos') && !window.location.origin.replaceAll('http://','').replaceAll('https://','').includes('training');
        },
        async sendNotaToWhatssapp(el,selectedNota,selectedNotaDetail){
            if(!this.checkIsThisLive() && this.getSessionStorage('UserType') != 'ADMIN'){
                this.$swal({
                    icon: 'error',
                    title: 'Oops..',
                    text: "[TRAINING] AKSES DIBATASIN",
                })
                return;
            }

            if (!el) return;
            let d = await this.imageToPng(el);
            let message = `${this.isThisLive() ? '':'[ T E S T I N G ]'}\n\nSelamat ${this.getWaktuIndonesia()} Bapak/Ibu, Berikut ini transaksi anda pada *${selectedNota.ExhibitionOtherName ?? "nama_pameran"}*.\n\nTerima Kasih`
            const blob = await (await fetch(d)).blob();

            this.$swal.fire({
                title: '<span class="loader mt-3"></span>',
                allowEscapeKey: false,
                allowOutsideClick: false,
                allowEnterKey: false,
                showConfirmButton: false,
                heightAuto: true,
                width: 200,
                html: '<h4 class="fw-bolder">Loading</h4>',
            });

            try {
                const response = await this.uploadFile_('order/SendReceiptToWhatsapp', blob, true, 
                    {
                        orderId: selectedNotaDetail.Id
                    }, {
                        'message': message
                    });

                this.$swal.close();
                
                if (response.IsSuccess) {
                    this.$swal({
                        icon: 'success',
                        title: 'Yeay',
                        text: `${response.Data.message}`,
                    });
                } else {
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        html: `${(response.Data.message) ? response.Data.message : response}`,
                    })
                }
            } catch (error) {
                this.$swal.close();
                this.$swal({
                    icon: 'error',
                    title: 'Oops..',
                    text: error,
                })
            }
        },
        async downloadNota(el) {
            if (!el) return;
            this.imageToPng(el).then((dataUrl) => {
                const link = document.createElement('a');
                link.download = 'nota.png';
                link.href = dataUrl;
                link.click();
            }).catch((error) => {
                console.error('Failed to export image', error);
            });
        },
        imageToPng(el){
            return toPng(el, {
                pixelRatio: 3,
                quality: 1,
                backgroundColor: '#ffffff',
            })
        },
        generateViewNota(dataList, order, name) {
            const exhibitionName = dataList.ExhibitionOtherName;
            const companyPhone = order.CompanyPhoneNumber || "";
            const dateRange = this.formatExhibitionDateRange(dataList.ExhibitionStartDate, dataList.ExhibitionEndDate);
            const orderNoFormatted = this.changeOrderNoFormat(dataList.OrderNo, dataList.MasterExhibitionId);
            const orderDateStr = moment(order.OrderDate).format("DD-MM-YYYY");
            const customerName = dataList.CustomerName;
            const spgName = dataList.SpgName;

            const itemLinesHtml = order.Details.filter(x => !x.ToNote).map(item => {
                const unitPrice = item.OrderPrice > 0
                ? item.OrderPrice
                : (item.ExtraDiscountNote?.Price || 0);
                const totalPrice = item.OrderQty * unitPrice;

                const prefix = item.OrderIsRaft ? "[+R] " : "";
                const star = item.OrderPrice == 0 ? "* " : "";
                const itemName = `${prefix}${star}${item.MasterItemLongDesc}`;

                return `<div class="d-flex justify-content-between mt-2">
                        <div class="w-100 lh-sm">
                            ${itemName}
                            <div class="d-flex w-100 justify-content-between">
                                <div>${item.OrderQty} x ${unitPrice.toLocaleString("id-ID")}</div>
                                <div>${totalPrice.toLocaleString("id-ID")}</div>
                            </div>
                        </div>
                    </div>`;
            }).join("");

            const totalSum = order.Details.reduce((acc, v) => {
            const price = v.OrderPrice > 0
                ? v.OrderPrice
                : (v.ExtraDiscountNote?.Price || 0);
                return acc + v.OrderQty * price;
            }, 0);

            const totalRakit = order.OrderCost1;
            const totalOngkir = order.OrderCost2;
            const totalLainLain = order.OrderCost3;

            const diskonItemSum = order.Details.filter(v => v.OrderPrice == 0).reduce((acc, v) => acc + v.OrderQty * (v.ExtraDiscountNote?.Price || 0), 0);

            const totalDiskon = order.OrderDiscount;
            const grandTotal = order.OrderGrandTotal;

            let totalsHtml = `
            <div class="d-flex justify-content-between">
                <div>Total</div>
                <div>${totalSum.toLocaleString("id-ID")}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>B. Rakit</div>
                <div>${totalRakit.toLocaleString("id-ID")}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>B. Ongkir</div>
                <div>${totalOngkir.toLocaleString("id-ID")}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>B. Lain‐lain</div>
                <div>${totalLainLain.toLocaleString("id-ID")}</div>
            </div>`;

            if(diskonItemSum > 0){
                totalsHtml+=` <div class="d-flex justify-content-between">
                <div>* Diskon</div>
                <div>${diskonItemSum.toLocaleString("id-ID")}</div>
                </div>`;
            }
            if(totalDiskon > 0){
                totalsHtml+=`<div class="d-flex justify-content-between">
                    <div>Diskon</div>
                    <div>${totalDiskon.toLocaleString("id-ID")}</div>
                </div>`;
            }
            
            totalsHtml += `<div style="border-top: 1px solid #000; margin: 4px 0;"></div>
            <div class="d-flex flex-row justify-content-between">
                <div>Grand Total</div>
                <div>${grandTotal.toLocaleString("id-ID")}</div>
            </div>`;

            let paymentHtml = "";
            if (order.Pays?.length > 0) {
                order.Pays.forEach(p => {
                    const metode = p.PaymentMethodName || "METODE PEMBAYARAN";
                    const amount = p.PaymentAmount;
                    paymentHtml += `
                    <div class="d-flex flex-row justify-content-between mt-2">
                        <div>${metode}</div>
                        <div>${amount.toLocaleString("id-ID")}</div>
                    </div>
                    `;
                });
                
                const sisa = (order.OrderGrandTotal - order.OrderPayTotal);
                const status = this.CheckPaymentStatusNota(order.OrderGrandTotal, order.OrderPayTotal);
                
                paymentHtml += `
                <div class="lh-sm">
                    <div class="d-flex flex-row justify-content-between mt-2">
                        <div>Sisa Pembayaran</div>
                        <div>${sisa.toLocaleString("id-ID")}</div>
                    </div>
                    <div class="d-flex flex-row justify-content-between">
                        <div>Status Pembayaran</div>
                        <div>${status}</div>
                    </div>
                </div>`;
            }

            let toNoteHtml = "";
            const toNoteItems = order.Details.filter(x => x.ToNote);
            if (toNoteItems.length) {
                toNoteHtml += `<div style="border-top:1px solid #000;"></div>`;
                toNoteHtml += `<div class="fw-bolder">Keterangan:</div>`;
                toNoteItems.forEach(i => {
                    toNoteHtml += `
                    <div class="lh-sm">
                        [${i.MasterItemLongDesc} × ${i.OrderQty}]
                    </div>`;
                });
            }

            const timestamp = moment().format("DD-MM-YYYY HH:mm:ss");
            const footerHtml = `
                <div style="border-top:1px solid #000;"></div>
                <div class="text-center">Terima Kasih!</div>
                <div class="text-center">${timestamp}</div>
                <div class="text-center">${name}</div>`;

            const html = `
                <div style="position:relative;width: 300px !important; max-width: 300px !important; min-width: 300px !important; font-size:10px !important;padding: 12px !important;color: #000 !important; background: #fff !important; font-family: 'Courier New', Courier, monospace !important; box-sizing: border-box !important;" class="border rounded shadow py-3">
                    
                    

                    <!-- HEADER -->
                    <div style="text-align:center; margin-bottom: 8px;" class="lh-sm">
                        <div style="font-size:12px; font-weight:bold;">${exhibitionName}</div>
                        ${companyPhone ? `<div style="font-size:10px;">${companyPhone.replaceAll('\\N','<br>')}</div>` : ""}
                        <div style="font-size:10px;">${dateRange}</div>
                    </div>

                    <!-- INFORMASI ORDER -->
                    <div style="margin-bottom: 6px; font-size:10px;" class="lh-sm">
                        <div style="display:flex; justify-content:space-between;">
                            <div>${orderNoFormatted}</div><div>${orderDateStr}</div>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <div>Pelanggan</div><div>${customerName}</div>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <div>SPG</div><div>${spgName}</div>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <div>${dataList.HandCarry}</div>
                            <div>${moment(order.ShipDate).format("DD-MM-YYYY")}</div>
                        </div>
                    </div>
                    
                    <div style="border-top:1px solid #000;"></div>
                    <div class="pb-2">${itemLinesHtml}</div>
                    <div style="border-top:1px solid #000;"></div>
                    <div class="lh-sm py-2">${totalsHtml}</div>
                    ${paymentHtml ? `<div style="margin-bottom: 6px;">${paymentHtml}</div>` : ""}
                    ${toNoteHtml}
                    ${footerHtml}
                    <div style="border-top:1px solid #000;"></div>
                </div>`;

            return html;
        },  
        generateViewNotaPRJ(dataList, order, name) {
            const exhibitionName = dataList.ExhibitionOtherName;
            const companyPhone = order.CompanyPhoneNumber || "";
            const dateRange = this.formatExhibitionDateRange(dataList.ExhibitionStartDate, dataList.ExhibitionEndDate);
            const orderNoFormatted = this.changeOrderNoFormat(dataList.OrderNo, dataList.MasterExhibitionId);
            const orderDateStr = moment(order.OrderDate).format("DD-MM-YYYY");
            const customerName = dataList.CustomerName;
            const spgName = dataList.SpgName;

            let itemLinesHtml = order.Details.filter(x => !x.ToNote).map(item => {
                const unitPrice = item.OrderPrice > 0
                ? item.OrderPrice
                : (item.ExtraDiscountNote?.Price || 0);
                const totalPrice = item.OrderQty * unitPrice;

                const prefix = item.OrderIsRaft ? "[+R] " : "";
                const star = item.OrderPrice == 0 || (((item.OrderPrice * item.OrderQty) - item.OrderDiscount) == 0)? "* " : "";
                const itemName = `${prefix}${star}${item.MasterItemLongDesc}`;

                return `<div class="d-flex justify-content-between mt-2">
                        <div class="w-100 lh-sm">
                            ${itemName}
                            <div class="d-flex w-100 justify-content-between">
                                <div>${item.OrderQty} x ${unitPrice.toLocaleString("id-ID")}</div>
                                <div>${totalPrice.toLocaleString("id-ID")}</div>
                            </div>
                        </div>
                    </div>`;
            }).join("");

            itemLinesHtml += order.Details2.filter(x => !x.ToNote).map(item => {
                const unitPrice = item.price;
                const totalPrice = item.Qty * item.price;

                const prefix = item.OrderIsRaft ? "[+R] " : "";
                const star = "* ";
                const itemName = `${prefix}${star}${item.RewardName}`;

                return `<div class="d-flex justify-content-between mt-2">
                        <div class="w-100 lh-sm">
                            ${itemName}
                            <div class="d-flex w-100 justify-content-between">
                                <div>${item.Qty} x ${unitPrice.toLocaleString("id-ID")}</div>
                                <div>${totalPrice.toLocaleString("id-ID")}</div>
                            </div>
                        </div>
                    </div>`;
            }).join("");

            let totalSum = order.Details.reduce((acc, v) => {
                const price = v.OrderPrice > 0
                    ? v.OrderPrice
                    : (v.ExtraDiscountNote?.Price || 0);
                    return acc + v.OrderQty * price;
            }, 0);
            
            totalSum += order.Details2.reduce((acc, v) => {
                const price = v.price
                return acc + v.Qty * price;
            }, 0);

            const totalRakit = order.OrderCost1;
            const totalOngkir = order.OrderCost2;
            const totalLainLain = order.OrderCost3;

            let diskonItemSum = order.Details.reduce((acc, val) => {
                let harga = val.OrderPrice;
                let subTotal = 0;
                if (val.OrderPrice == 0) {
                    if (!val.ToNote) {
                        harga = (val.ExtraDiscountNote?.Price ?? 0);
                    }
                    subTotal = (val.OrderQty * harga);
                } else {
                    subTotal = val.OrderDiscount ?? 0;
                }

                return acc + subTotal;

            }, 0);
            diskonItemSum += order.Details2.reduce((acc, v) => acc + v.Qty * v.price, 0);

            const totalDiskon = order.OrderDiscount;
            const grandTotal = order.OrderGrandTotal;

            let totalsHtml = `
            <div class="d-flex justify-content-between">
                <div>Total</div>
                <div>${totalSum.toLocaleString("id-ID")}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>B. Rakit</div>
                <div>${totalRakit.toLocaleString("id-ID")}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>B. Ongkir</div>
                <div>${totalOngkir.toLocaleString("id-ID")}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>B. Lain‐lain</div>
                <div>${totalLainLain.toLocaleString("id-ID")}</div>
            </div>`;

            if(diskonItemSum > 0){
                totalsHtml+=` <div class="d-flex justify-content-between">
                <div>* Diskon</div>
                <div>${diskonItemSum.toLocaleString("id-ID")}</div>
                </div>`;
            }
            if(totalDiskon > 0){
                totalsHtml+=`<div class="d-flex justify-content-between">
                    <div>Diskon</div>
                    <div>${totalDiskon.toLocaleString("id-ID")}</div>
                </div>`;
            }
            
            totalsHtml += `<div style="border-top: 1px solid #000; margin: 4px 0;"></div>
            <div class="d-flex flex-row justify-content-between">
                <div>Grand Total (Termasuk PPN)</div>
                <div>${grandTotal.toLocaleString("id-ID")}</div>
            </div>`;

            let paymentHtml = "";
            if (order.Pays?.length > 0) {
                order.Pays.forEach(p => {
                    const metode = p.PaymentMethodName || "METODE PEMBAYARAN";
                    const amount = p.PaymentAmount;
                    paymentHtml += `
                    <div class="d-flex flex-row justify-content-between mt-2">
                        <div>${metode}</div>
                        <div>${amount.toLocaleString("id-ID")}</div>
                    </div>
                    `;
                });
                
                const sisa = (order.OrderGrandTotal - order.OrderPayTotal);
                const status = this.CheckPaymentStatusNota(order.OrderGrandTotal, order.OrderPayTotal);
                
                paymentHtml += `
                <div class="lh-sm">
                    <div class="d-flex flex-row justify-content-between mt-2">
                        <div>Sisa Pembayaran</div>
                        <div>${sisa.toLocaleString("id-ID")}</div>
                    </div>
                    <div class="d-flex flex-row justify-content-between">
                        <div>Status Pembayaran</div>
                        <div>${status}</div>
                    </div>
                </div>`;
            }

            let toNoteHtml = "";
            const toNoteItems = order.Details.filter(x => x.ToNote);
            if (toNoteItems.length) {
                toNoteHtml += `<div style="border-top:1px solid #000;"></div>`;
                toNoteHtml += `<div class="fw-bolder">Keterangan:</div>`;
                toNoteItems.forEach(i => {
                    toNoteHtml += `
                    <div class="lh-sm">
                        [${i.MasterItemLongDesc} × ${i.OrderQty}]
                    </div>`;
                });
            }

            const timestamp = moment().format("DD-MM-YYYY HH:mm:ss");
            const footerHtml = `
                <div style="border-top:1px solid #000;"></div>
                <div class="text-center">Terima Kasih!</div>
                <div class="text-center">${timestamp}</div>
                <div class="text-center">${name}</div>`;

            const html = `
                <div style="position:relative;width: 300px !important; max-width: 300px !important; min-width: 300px !important; font-size:10px !important;padding: 12px !important;color: #000 !important; background: #fff !important; font-family: 'Courier New', Courier, monospace !important; box-sizing: border-box !important;" class="border rounded shadow py-3">
                    
                    

                    <!-- HEADER -->
                    <div style="text-align:center; margin-bottom: 8px;" class="lh-sm">
                        <div style="font-size:12px; font-weight:bold;">${exhibitionName}</div>
                        ${(companyPhone  && companyPhone != 0 &&  companyPhone != '0') ? `<div style="font-size:10px;">${companyPhone.replaceAll('\\N','<br>')}</div>` : ""}
                        <div style="font-size:10px;">${dateRange}</div>
                    </div>

                    <!-- INFORMASI ORDER -->
                    <div style="margin-bottom: 6px; font-size:10px;" class="lh-sm">
                        <div style="display:flex; justify-content:space-between;">
                            <div>${orderNoFormatted}</div><div>${orderDateStr}</div>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <div>Pelanggan</div><div>${customerName}</div>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <div>SPG</div><div>${spgName}</div>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <div>${dataList.HandCarry}</div>
                            <div>${moment(order.ShipDate).format("DD-MM-YYYY")}</div>
                        </div>
                    </div>
                    
                    <div style="border-top:1px solid #000;"></div>
                    <div class="pb-2">${itemLinesHtml}</div>
                    <div style="border-top:1px solid #000;"></div>
                    <div class="lh-sm py-2">${totalsHtml}</div>
                    ${paymentHtml ? `<div style="margin-bottom: 6px;">${paymentHtml}</div>` : ""}
                    ${toNoteHtml}
                    ${footerHtml}
                    <div style="border-top:1px solid #000;"></div>
                </div>`;

            return html;
        },
        formatExhibitionDateRange(startDate, endDate) {
            const start = moment(startDate);
            const end = moment(endDate);
            return (start.isSame(end, 'month')) ? `${start.format("D")} - ${end.format("D MMMM YYYY")}` : `${start.format("D MMMM")} - ${end.format("D MMMM YYYY")}`;
        },
        changeOrderNoFormat(orderNo, exhibId){
            return "#"+ `${exhibId}`.padStart(5,"0") + " " + orderNo.replaceAll("DC_", "").replaceAll("GMB_","");
        },
        getWaktuIndonesia(m = moment()) {
            const jam = m.hour(); // mengambil jam (0–23)
            if (jam >= 3 && jam < 10) {
                return 'Pagi';
            } else if (jam >= 10 && jam < 15) {
                return 'Siang';
            } else if (jam >= 15 && jam < 18) {
                return 'Sore';
            } else {
                return 'Malam';
            }
        },
        formatCompactCurrencyNumber(value) {
            return new Intl.NumberFormat('id-ID', {
                notation: 'compact',
                compactDisplay: 'short'
            }).format(value);
        },
        formatDateAndTime(value){
            return (value) ? moment(String(value)).format('DD/MM/YYYY HH:mm:ss') : "";
        },
        formatNumberToCurrency(value) {
            return Number(value).toLocaleString('id-ID', {maximumFractionDigits: 0, style:"currency", currency:"IDR"})
        },
        formatNumberr(value){
            return value.toLocaleString('id-ID', { maximumFractionDigits: 0 });
        },
        formatNumberToPercent(value){
            return Number(value).toFixed(2) + "% "
        },
        formatNumber(value,berapaAngkabelakang = 0){
            return Number(value).toFixed(berapaAngkabelakang);
        },
        formatNumberTwoDigitsBehind(value){
            return Number(value).toFixed(2);
        },
        formatInputDate(date, join = '/') {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
        
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
        
            return [month, day, year].join( join );
        },
        logout() {
            window.sessionStorage.clear();
            this.$router.push( { path: '/login' } );
            return;
        },
        getToken() {
            const token = this.getSessionStorage("Token");
            if(!token) return this.logout();
            return `Bearer ${token}`;
        },
        async fetchData_(url, params = {}, method = 'GET', isLoading = false) {
            // let loader;
            if (isLoading) {
                // loader = this.$loading.show({ "z-index": 999999 })
                this.$swal.fire({
                    title: '<span class="loader mt-3"></span>',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    showConfirmButton: false,
                    heightAuto: true,
                    width: 200,
                    html: '<h4 class="fw-bolder">Memuat...</h4>',
                    });
            }
            var headers = { 
                "Access-Control-Allow-Origin": "*",
                "Authorization": this.getToken(),
                'Content-Type': 'application/json'
            } 
            try {
                let payload={};
                switch(method){
                    case 'GET':
                        payload =  {
                            method,
                            headers,
                        };
                        url += "?"
                        url += new URLSearchParams(params)
                        break;
                    default : 
                        payload =  {
                            method,
                            headers,
                            body: JSON.stringify(params),
                            credentials: 'same-origin'
                        };
                    break
                }
                
                

                const response = await fetch(process.env.VUE_APP_BASE_URL + url, payload);
              
                if(isLoading) this.$swal.close(); 
                    // loader.hide();
                if ( [200,201].find(x => x == response.status) ) return response.json()
                else if ( [400].find(x => x == response.status) ) {
                    if (method == 'GET') return Promise.reject(response)
                    else return response.json();
                }
                else if ( [401].find(x => x == response.status) ) this.logout();
                else if ( [404, 408].find(x => x == response.status) ) return Promise.reject(response)
                else if ( [403].find(x => x == response.status) ) return Promise.reject("Maap anda tidak memiliki Hak Akses 🙏, Silahkan Hubungin Admin!")
                else return Promise.reject("Maap terjadi Error di sisi server 🙏");
            } catch (error) {
                if (isLoading) this.$swal.close();
            
                if (error instanceof TypeError) {
                    return Promise.reject("Gagal terhubung ke server. Silakan periksa koneksi internet Anda atau coba lagi nanti.");
                }

                return Promise.reject(error.response ? error.response : error);
            }
        },
        async fetchReport_(url, params = {}, isLoading = false) {
            // let loader;
            if (isLoading) {
                // loader = this.$loading.show({ "z-index": 999999 })
                this.$swal.fire({
                    title: '<span class="loader mt-3"></span>',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    showConfirmButton: false,
                    heightAuto: true,
                    width: 200,
                    html: '<h4 class="fw-bolder">Loading</h4>',
                    });
            }
            var headers = { 
                "Access-Control-Allow-Origin": "*",
                "Authorization": this.getToken(),
                'Content-Type': 'application/json'
            } 
            try {
                let payload={
                    responseType: 'blob',
                    method: 'POST',
                    headers,
                    body: JSON.stringify(params),
                    credentials: 'same-origin'
                };
                const response = await fetch(process.env.VUE_APP_BASE_URL + url, payload);
                if(isLoading) this.$swal.close(); 
                    // loader.hide();
                if ( response.ok ) return response.blob()
                else return Promise.reject("Gagal download!");
            } catch (error) {
                // console.log(error)
                if(isLoading) this.$swal.close(); // loader.hide();
                return Promise.reject(error.response ? error.response: error)
            }
        },
        async uploadFile_(url, file, isLoading = false, params = {}, anotherData = {}) {
            // Show loading spinner if `isLoading` is true
            if (isLoading) {
                this.$swal.fire({
                    title: '<span class="loader mt-3"></span>',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    showConfirmButton: false,
                    heightAuto: true,
                    width: 200,
                    html: '<h4 class="fw-bolder">Loading</h4>',
                });
            }
        
            // Prepare headers, but omit 'Content-Type' because the browser will handle it when using FormData
            var headers = { 
                "Access-Control-Allow-Origin": "*",
                "Authorization": this.getToken(),
                // No need to set Content-Type here
            };
        
            // Create a FormData object to include the file and any additional parameters
            let formData = new FormData();
            formData.append('file', file);  // append the file
            if(Object.keys(anotherData).length != 0){
                Object.entries(anotherData).forEach(([key, value]) => {
                    formData.append(key, value);
                });
            }
            try {
                // Prepare the fetch payload
                let payload = {
                    method: 'POST',
                    headers,
                    body: formData,  // Use FormData as the body
                    credentials: 'same-origin'
                };
                
                url += "?"
                url += new URLSearchParams(params)

                // Send the request
                const response = await fetch(process.env.VUE_APP_BASE_URL + url, payload);
        
                // Close the loading modal if it's open
                if (isLoading) this.$swal.close();
                // Handle the response
                if (response.ok) {
                    return await response.json();  // Assuming server returns JSON
                
                } else {
                    if ([400].find(x => x == response.status) ) {
                        return response.json();
                    }else{
                        return Promise.reject("Upload failed!");
                    }
                }
            } catch (error) {
                if (isLoading) this.$swal.close();
                if (error instanceof TypeError) {
                    return Promise.reject("Gagal terhubung ke server. Silakan periksa koneksi internet Anda atau coba lagi nanti.");
                }
                return Promise.reject(error.response ? error.response : error);
            }
        },        
        downloadFile(blob, name = "Report.xlsx") {
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name); // Specify the file name

            document.body.appendChild(link);
            link.click();
        },
        async getDataById_(id, url) {
            try {
                const response = await this.fetchData_(url + '/' + id, {}, 'GET', true);
                var data = response.Data
                this.$store.state[this.$router.currentRoute.value.path] = data;
            } catch (error) {
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.statusText,
                })  
                
                return Promise.reject(error)
            }
        },
        getSessionStorage(key){
            const data = window.sessionStorage.getItem('expos');
            if(!data) return this.logout();
            const parsedData = JSON.parse(data);
            return parsedData[key];
        },
        async removeViewMode(url, id) {
            this.$swal({
                title: "Apakah anda yakin menghapus data ini?",
                icon:'warning',
                showCancelButton: true,
                confirmButtonText: "Hapus",
                cancelButtonText: 'Batal'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const response = await this.fetchData_(url + '/' + id, {}, 'DELETE', true);
                        this.$swal({
                            icon: 'success',
                            title: 'Data telah di hapus',
                            text: response.statusText,
                        });
                        this.$refs.dataTable.load()
                    } catch (error) { 
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: error.statusText,
                        })
                    }
                }
            })
            
        }
    }
}
